module.exports = __webpack_public_path__ + "static/media/gps-tracking.43d676ea.svg";